import * as React from 'react';

import { Box, Link } from '@mui/material';

import ReactGA from 'react-ga4';

import SkillzInfoIcon from '@app/imageAssets/Dashboard/skillzBrandedInfoIcon.svg';
import SkillzLogo from '@app/imageAssets/sidebar/skillzLogo.svg';

import { GOOGLE_ANALYTICS_4 } from '../constants';

export enum DISCORD_INVITE_LOCATION {
  NAVBAR = 'navbar',
  SUPPORT_PAGE = 'support_page',
  INTEGRATION_COMPLETE = 'integration_complete',
}

function openDiscord(pageName: DISCORD_INVITE_LOCATION) {
  trackClick(pageName);
  window.open(window.appConfig.environment.discordInviteUrl);
}

function trackClick(pageName: DISCORD_INVITE_LOCATION) {
  ReactGA.event({
    category: GOOGLE_ANALYTICS_4.USER.CATEGORY,
    action: GOOGLE_ANALYTICS_4.USER.ACTIONS.DISCORD_INVITE_CLICK(pageName),
  });
}

interface IDiscordInviteProps {
  location: DISCORD_INVITE_LOCATION;
}

export function DiscordInviteLink({ location }: IDiscordInviteProps): JSX.Element {
  return (
    <Box
      sx={{
        backgroundColor: '#EEE',
        borderRadius: '10px',
        display: 'flex',
        alignItems: 'center',
      }}
      p={1}
    >
      <Box component="img" src={SkillzInfoIcon} />
      <Box sx={{ marginLeft: '15px' }}>
        Need additional support? &nbsp;
        <Link
          id="discord-invite-link"
          color="#3E00CD"
          onClick={() => openDiscord(location)}
          underline="none"
          data-qa="discord-invite-link"
        >
          Join our Skillz Developer Discord
        </Link>
        &nbsp; to meet like-minded game developers and talk to our Developer Success team.
      </Box>
    </Box>
  );
}

export function DiscordInviteButton({ location }: IDiscordInviteProps): JSX.Element {
  return (
    <Box
      sx={{ padding: '10px' }}
      onClick={() => openDiscord(location)}
      data-qa="discord-invite-button"
    >
      <Box
        sx={{
          padding: '12px',
          backgroundColor: '#fff',
          borderRadius: '12px',
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'row',
          cursor: 'pointer',
          justifyContent: 'space-around',
        }}
      >
        <Box sx={{ paddingTop: '2px' }}>
          <Box component="img" src={SkillzLogo} />
        </Box>
        <Box sx={{ marginLeft: '5px' }}>
          <Box sx={{ fontSize: '17px' }}>JOIN SKILLZ</Box>
          <Box sx={{ fontSize: '12px' }}>DEV COMMUNITY</Box>
        </Box>
      </Box>
    </Box>
  );
}
